import {
  Color,
  ColorDynamic,
  Column,
  Columns,
  Inline,
  Stack,
} from '@superdispatch/ui';
import { TextBox } from '@superdispatch/ui-lab';
import styled from 'styled-components';
import { CombinedLoadDTO } from '../data/LoadDTO';

const GutterRoot = styled.div`
  min-height: 44px;
  height: 100%;
  padding: 4px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const GutterPoint = styled.div`
  width: 8px;
  height: 8px;
  display: block;
  border-radius: 50%;
  &[data-start='true'] {
    background: ${Color.Yellow300};
  }
  &[data-middle='true'] {
    margin-top: 4px;
    margin-bottom: 4px;
    border: 1px solid ${Color.Dark100};
  }
  &[data-end='true'] {
    border-radius: 12.5%;
    background: ${Color.Green300};
  }
`;
const GutterLine = styled.div`
  flex: 1;
  width: 2px;
  background: repeating-linear-gradient(
    ${ColorDynamic.Dark100},
    ${ColorDynamic.Dark100} 3px,
    transparent 3px,
    transparent 5px
  );
`;
function Gutter() {
  return (
    <GutterRoot>
      <GutterPoint data-start="true" />
      <GutterLine />
      <GutterPoint data-end="true" />
    </GutterRoot>
  );
}
interface LoadWaypointsProps {
  load: CombinedLoadDTO;
}

export function LoadOrderWaypoints({ load }: LoadWaypointsProps) {
  if (!load.pickup_city) {
    return null;
  }
  return (
    <Columns space="xxsmall">
      <Column width="content">{load.delivery_city ? <Gutter /> : null}</Column>
      <Column width="fluid">
        <Stack space="xxsmall">
          <Inline>
            <TextBox
              noWrap={true}
              wrapOverflow={true}
              aria-label="Pickup address"
            >
              {load.pickup_city}, {load.pickup_state} {load.pickup_zip}
            </TextBox>
          </Inline>
          <Inline>
            <TextBox
              noWrap={true}
              wrapOverflow={true}
              aria-label="Delivery address"
            >
              {load.delivery_city}, {load.delivery_state} {load.delivery_zip}
            </TextBox>
          </Inline>
        </Stack>
      </Column>
    </Columns>
  );
}
